/* Technical skills grid icons for the About page */
import C from "../Assets/TechIcons/C++.svg";
import Javascript from "../Assets/TechIcons/Javascript.svg";
import Python from "../Assets/TechIcons/Python.svg";
import Git from "../Assets/TechIcons/Git.svg";
import Node from "../Assets/TechIcons/Node.svg";
import ReactIcon from "../Assets/TechIcons/React.svg";
import Terminal from "../Assets/TechIcons/Terminal.svg";
import Julia from "../Assets/TechIcons/Julia.svg";
import CSS from "../Assets/TechIcons/Css.svg";
import Pandas from "../Assets/TechIcons/Pandas.svg";
import Latex from "../Assets/TechIcons/Latex.svg";
import SQL from "../Assets/TechIcons/SQL.svg";
import numpy from "../Assets/TechIcons/numpy.svg";
import matplotlib from "../Assets/TechIcons/graph.svg";
import MATLAB from "../Assets/TechIcons/Matlab.svg";
import Typescript from "../Assets/TechIcons/typescript.svg";
import MT5 from "../Assets/TechIcons/mt5.svg";

export const techIcons = [
    { icon: Python, alt: "Python", label: "Python" },
    { icon: numpy, alt: "numpy", label: "numpy" },
    { icon: matplotlib, alt: "Matplotlib", label: "Matplotlib" },
    { icon: Pandas, alt: "Pandas", label: "Pandas" },
    { icon: MT5, alt: "MetaTrader 5", label: "MetaTrader 5" },
    { icon: C, alt: "C++", label: "C++" },
    { icon: Julia, alt: "julia", label: "Julia" },
    { icon: Terminal, alt: "terminal", label: "CLI/bash/SSH" },
    { icon: Git, alt: "git", label: "Git" },
    { icon: Latex, alt: "latex", label: "LaTeX" },
    { icon: Javascript, alt: "javascript", label: "Javascript" },
    { icon: Typescript, alt: "Typescript", label: "Typescript" },
    { icon: MATLAB, alt: "MATLAB", label: "MATLAB" },
    { icon: Node, alt: "node", label: "Node.Js" },
    { icon: ReactIcon, alt: "react", label: "React.Js" },
    { icon: CSS, alt: "CSS", label: "CSS" },
    { icon: SQL, alt: "sql", label: "SQL" },
];
